import editBasicInfoOfOneUser from './editBasicInfoOfOneUser'
import editPermissionsOfOneUserSagas from './editPermissionsOfOneUser'

export default [
  ...editBasicInfoOfOneUser,
  ...editPermissionsOfOneUserSagas,
]
